/* eslint-disable react/display-name */
import React from 'react';
import * as Flags from 'country-flag-icons/react/3x2';

const OfflineFlag = ({ iso2, style, className }: { iso2: string; style?: React.CSSProperties; className?: string }) => {
  const FlagComponent = Flags[iso2.toUpperCase() as keyof typeof Flags];

  if (FlagComponent) {
    return <FlagComponent style={style} className={className} title={iso2.toUpperCase()} />;
  }

  // Fallback if flag not found (shouldn't happen for standard ISO codes)
  return <span style={style} className={className}>{iso2.toUpperCase()}</span>;
};

export default OfflineFlag;
